const transfers = {
  transfer: "Chuyển khoản", // translated 
  transfers: "Chuyển nhượng", // translated 
  dateAndTime: "Ngày và giờ", // translated 
  transferFrom: "Chuyển khoản từ", // translated 
  duration: "Khoảng thời gian", // translated 
  numOfPersons: "Số lượng người", // translated 
  baggageAllowance: "Quy định về hành lý", // translated 
  small: "Bé nhỏ", // translated 
  big: "To lớn", // translated 
  provider: "Nhà cung cấp", // translated 
  vehicle: "Phương tiện giao thông", // translated 
  distance: "Khoảng cách", // translated 
  price: "Giá", // translated 
  inboundJourney: "Hành trình đến", // translated 
  outboundJourney: "Hành trình đi ra", // translated 
  arrivalTime: "Thời gian đến", // translated 
  flightDetails: "Thông tin chi tiết chuyến bay", // translated 
  inboundPickupDate: "Ngày nhận hàng", // translated 
  outboundPickupDate: "Ngày nhận hàng đi", // translated 
  travelInfo: "Thông tin du lịch", // translated 
  travellersInformation: "Thông tin dành cho du khách", // translated 
  flightsInfo: "Thông tin chuyến bay", // translated 
  airportYouAreFlyingFrom: "Sân bay bạn khởi hành", // translated 
  airportYouAreFlyingTo: "Sân bay bạn sẽ bay đến", // translated 
  inboundFlightNumber: "Số hiệu chuyến bay đến", // translated 
  outboundFlightNumber: "Số hiệu chuyến bay đi", // translated 
  inboundAirlineName: "Tên hãng hàng không đến", // translated 
  outboundAirlineName: "Tên hãng hàng không khởi hành", // translated 
  tripMode: "Chế độ hành trình", // translated 
  airportToPoint: "Sân bay đến điểm", // translated 
  pointToAirport: "Điểm đến sân bay", // translated 
  roundTrip: "Khứ hồi", // translated 
  destinationPoint: "Điểm đến", // translated 
  originPoint: "Điểm xuất phát", // translated 
  transferType: "Loại chuyển đổi", // translated 
  min: "Tối thiểu", // translated 
  max: "Tối đa", // translated 
  pieces: "Mảnh", // translated 
  cancelationIs: "việc hủy bỏ là", // translated 
};


export default transfers;
